export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11247.e7aae82e.jpg";